/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import {
  my, m, ml, mt, mx
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import Grid from 'styled-components-grid';
import {
  VerifyIcon,
  LocationIcon,
  RatingStars5,
  Star4,
  PlayIcon
} from '@images/svg/index';

export const StyledCover = styled.div`
  max-width: 1200px;
  margin: auto;
  width: 100%;
  ${my(4)}
`;

export const HeadingBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  color: #575757;
  margin-bottom: 2rem;
  margin-top: 1rem;
  ${breakpoint('mobile', 'tablet')`
      ${mx(2)}
    `}
`;

export const StyledHeading = styled.h3`
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0em;
  text-align: center;

  ${breakpoint('mobile', 'tablet')`
        font-size: 24px;
        line-height: 30px;
    `}

  ${breakpoint('tablet', 'desktop')`
        font-size: 36px;
        line-height: 42px;
    `}
`;

export const StyledCardWrapper = styled.div`
  flex: 1;
  cursor: pointer;
  padding:20px;
  padding-top: 15px;
  border-radius: 10px;
  background-color: ${props => props.backgroundColor || 'black'};
  ${m(3)} 
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${breakpoint('mobile', 'tablet')`
    height: 340px;
  `}
`;

export const Article = styled.div`
  font-size: 16px;
  line-height: 22px;
  /* height: 220px; */
  ${mt(3)}
  @media (max-width: 735px) {
    height: auto;
  }

  @media (max-width: 500px) {
    height: auto;
    font-size: 14px;
    line-height: 20px;
  }

  @media (max-width: 400px) {
    font-size: 14px;
  }

  ${({ blogLink }) =>
    blogLink
      && `
      pointer-events: none; 
      cursor: not-allowed;
    `}
`;

export const StyledVerifyIcon = styled(VerifyIcon)`
  height: 15px;
  width: auto;
  margin-left: auto;

  ${breakpoint('mobile', 'tablet')`
    height:20px;
  `}
`;

export const PatientImageWrapper = styled.div`
  flex: 0 0 35%;
  position: relative;
  /* width: 110px; */
  height: 100px;
  display: inline-block;

  ${({ shadow }) => shadow && `
  ::before {
    z-index: 99;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(114, 115, 114, 0.512) 0%, rgba(55, 57, 56, 0) 86.15%);
    pointer-events: none;
    border-radius: 8px; 
  }
    `}

  @media (max-width: 1255px) {
    width: 100px;
    height: 100px;
  }

  @media (max-width: 800px) {
    height: 90px;
    width: 90px;
  }

`;

export const StyledPlayIcon = styled(PlayIcon)`
  top: 25%;
  left: 25%;
  width: 50%;
  height: 50%;
  position: absolute;
  z-index: 99;
  path{
    fill: #E7FFF8;
  }
`;

export const PatientImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  -webkit-user-drag: none;
  border-radius: 8px;
  position: relative;
  z-index: 1; 

  @media (max-width: 1255px) {
    /* width: 100px; */
    height: 100px;
  }

  @media (max-width: 800px) {
    height: 90px;
    /* width: 90px; */
  }

  /* @media (max-width: 500px) {
    height: 70px;
    /* width: 70px !important; 
  } */
`;

export const StyledPatientInfo = styled.div`
  width: 100%;
  display: flex;
`;

export const PatientName = styled.div`
  font-weight: 600;
  font-size: 15px;
  padding-top: 10px;
`;

export const StyledPatientDetails = styled.div`
  ${ml(3)}
  ${({ blogLink }) =>
    blogLink
      && `
      pointer-events: none; 
      cursor: not-allowed;
    `}
`;

export const PatientCountry = styled.div`
  font-size: 11px;
  padding-top:5px;
  display: flex;
  align-items: center;
`;

export const StyledReviewTime = styled.div`
  font-size: 11px;
  padding-top:5px;
  color:#575757;
`;

export const StyledCountryFlag = styled.img`
  height:16px;
  width:16px !important;
  margin-left: 5px;
`;

export const StyledLocationIcon = styled(LocationIcon)`
  height: 9px;
  width: 9px;
  margin-right: 3px;
`;


export const RatingStarIcon5 = styled(RatingStars5)`
  height: 19px;
  ${mt(3)}
    path{
      fill: #FFB525;
    }
  @media (max-width: 1255px) {
    height: 12px;
  }
  ${breakpoint('mobile', 'tablet')`
    height: 15px;
    ${mt(3)}
  `}
`;

export const StyledRatingStars = styled(Star4)`
  height: 19px;
  ${mt(3)}
  @media (max-width: 1255px) {
    height: 12px;
  }
  ${breakpoint('mobile', 'tablet')`
    height: 15px;
    ${mt(3)}
  `}
`;

export const StyledWrapper = styled(Grid.Unit)`
 display: grid;
 /* ${breakpoint('tablet', 'desktop')`
   margin 0rem 1rem;
   width: 63% !important;
  `} */
`;

export const StyledListItem = styled(Grid)`
  margin: 0 auto;
  overflow: hidden;
`;
